import React from 'react'
import I18N from '@leverege/i18n'
import { ItemModel } from '@leverege/ui-attributes'

import AisleHeatmapping from './AisleHeatmappingCards'

const id = 'ps.dataViewers.AisleHeatmappingSupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.AisleHeatmapping',
  name : tf( 'name', 'Aisle Heatmap' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : [ 'main', 'card' ],
  matches : { type : 'GroupDataViewer', objectType : 'aisle' },
  createSettings : ( props ) => {
    let mdl = ItemModel.create()
    mdl = ItemModel.addType( mdl, 'aisle' )

    return mdl
  },
  render : ( props ) => {
    return React.createElement( AisleHeatmapping, props )
  },
  getDefaultCardContentOptions : { height : '400px' },
}
